export const xss = (val) => {
  val = val.toString();
  val = val.replace(/</g, "&lt;");
  val = val.replace(/>/g, "&gt;");
  val = val.replace(/ /g, "&nbsp;");
  val = val.replace(/"/g, "&quot;");
  val = val.replace(/'/g, "&#39;");
  val = val.replace(/&lt;\/br&gt;/g, "</br>");
  return val;
}
